var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main",staticClass:"container-main",attrs:{"id":"scrollLoader-container"}},[_c('div',{style:('min-height:' + _vm.realMinHeight + 'px; overflow-x:hidden')},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }